import React, { useEffect, useState } from "react";
import { Badge, Button, Modal, Spinner } from "react-bootstrap";
import axios from "../../../config/axios";
import { useTranslation } from "react-i18next";
import EditInvoicePaymentDialog from ".././EditInvoicePaymentDialog";
import { dateTimeFormatter, euroFormatter } from "../../../global";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import EllipsisDropdown, {
  EllipsisDropdownItem,
  EllipsisDropdownSection,
} from "../../../components/EllipsisDropdown";

const InvoicePaymentsDialog = ({ handleSubmit, handleClose, invoice }) => {
  const [payments, setPayments] = useState();
  const [selectedPayment, setSelectedPayment] = useState();
  const { t } = useTranslation("dashboard");

  function reload() {
    axios.get(`/api/v1/invoices/${invoice.id}`).then(({ data }) => {
      setPayments(data.payments);
    });
  }

  function deletePayment(payment) {
    axios
      .delete(`/api/v1/invoices/${invoice.id}/payments/${payment.id}.json`)
      .then(({ data }) => {
        reload();
      });
  }

  function handlePaymentUpdated() {
    reload();
    setSelectedPayment(null);
  }

  useEffect(() => {
    reload();
  }, []);

  return (
    <>
      <Modal
        show={!selectedPayment}
        onHide={handleClose}
        dialogClassName={"invoice-payments-dialog"}
      >
        <Modal.Header closeButton>
          <Modal.Title>Zahlung hinzufügen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!payments ? (
            <Spinner
              className={"d-block mx-auto"}
              animation="border"
              variant="primary"
            />
          ) : (
            <div className="ui-table-container">
              <table>
                <thead>
                  <tr>
                    <th>Bezahlt am</th>
                    <th>Betrag</th>
                    <th>Zahlungsmethode</th>
                    <th>Typ</th>
                    <th>Aktionen</th>
                  </tr>
                </thead>
                <tbody>
                  {payments?.map((payment) => {
                    const canCreateRefund =
                      payment.payment_type === "stripe" &&
                      payment.type_of === "payment";
                    const canEditPayment = payment.is_editable;

                    return (
                      <tr key={payment.id}>
                        <td>{dateTimeFormatter(payment.paid_at)}</td>
                        <td>{euroFormatter(payment.amount)}</td>
                        <td>{payment.formatted_payment_type}</td>
                        <td>
                          <Badge
                            pill
                            className={"mr-2"}
                            variant={
                              payment.type_of === "payment"
                                ? "success"
                                : "secondary"
                            }
                            text="light"
                          >
                            {t(payment.formatted_type_of)}
                          </Badge>

                          {payment.api_error && (
                            <FontAwesomeIcon
                              icon={faTriangleExclamation}
                              className={"text-danger"}
                              title={"Fehler bei der Zahlung"}
                            />
                          )}
                        </td>
                        <td>
                          <EllipsisDropdown className={"m-2"}>
                            <EllipsisDropdownSection>
                              {canCreateRefund && (
                                <EllipsisDropdownItem
                                  onClick={() => {
                                    setSelectedPayment({
                                      invoice_id: invoice.id,
                                      stripe_payment_intent_id:
                                        payment.stripe_payment_intent_id,
                                      amount: payment.amount,
                                      payment_type: "stripe",
                                      type_of: "refund",
                                    });
                                  }}
                                >
                                  Stripe Zurückerstattung erstellen
                                </EllipsisDropdownItem>
                              )}
                              {canEditPayment && (
                                <EllipsisDropdownItem
                                  onClick={() => {
                                    setSelectedPayment(payment);
                                  }}
                                >
                                  Bearbeiten
                                </EllipsisDropdownItem>
                              )}
                            </EllipsisDropdownSection>
                            <EllipsisDropdownSection>
                              <EllipsisDropdownItem
                                onClick={() => {
                                  deletePayment(payment);
                                }}
                              >
                                Löschen
                              </EllipsisDropdownItem>
                            </EllipsisDropdownSection>
                          </EllipsisDropdown>
                        </td>
                      </tr>
                    );
                  })}
                  {payments.length === 0 && (
                    <tr>
                      <td colSpan={5}>
                        {t("common:components.table.noEntries")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("common:components.button.close")}
          </Button>
          <Button
            onClick={() => {
              setSelectedPayment({ invoice_id: invoice.id });
            }}
          >
            Zahlung hinzufügen
          </Button>
        </Modal.Footer>
      </Modal>
      {selectedPayment && (
        <EditInvoicePaymentDialog
          handleClose={() => {
            setSelectedPayment(null);
          }}
          handleSubmit={handlePaymentUpdated}
          payment={selectedPayment}
          invoice={invoice}
        />
      )}
    </>
  );
};

export default InvoicePaymentsDialog;
